import React, { useEffect } from "react";
import Cookies from "universal-cookie";
import { Scrollbars } from "react-custom-scrollbars-2";
import { FaCoins } from "react-icons/fa";
import { BsFillFileWordFill, BsFillCartCheckFill } from "react-icons/bs";
import { FcSurvey } from "react-icons/fc";
import { Link } from "react-router-dom";
import $ from "jquery";

const cookies = new Cookies();

const Sidebar = ({ type }) => {
  const localRole = JSON.parse(localStorage.getItem("role"))
  const permissions = localRole && localRole.permissions ? localRole.permissions : "All";
  useEffect(() => {
    if (window.innerWidth <= 768) {
      document.body.classList.remove("sidebar-enable");
    }
    $('.nav-second-level').removeClass('mm-show').addClass('mm-collapse');
    if (type === "sellProducts") {
      $('#sellProducts').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type === "buyProducts") {
      $('#buyProducts').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type === "businessProfiles") {
      $('#businessProfilesGrp').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type === "profiles") {
      $('#profilesGrp').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type === "subscription") {
      $('#subscriptionGrp').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type === "settings") {
      $('#settingsGrp').removeClass('mm-collapse').addClass('mm-show');
    }
    else if (type == "configurations") {
      $('#configGrp').removeClass('mm-collapse').addClass('mm-show');
    }
  }, []);

  const handleClick = (e) => {
    if ($(e.target).next().hasClass('mm-collapse')) {
      $('.nav-second-level').removeClass('mm-show').addClass('mm-collapse');
      $(e.target).next().removeClass('mm-collapse').addClass("mm-show");
    }
    else {
      $('.nav-second-level').removeClass('mm-show').addClass('mm-collapse');
    }
  };

  return (
    <div className="left-side-menu">
      <Scrollbars style={{ width: "100%", height: "100%" }}>
        <div id="sidebar-menu">
          <ul className="metismenu" id="side-menu">
            {permissions === "All" || permissions.some(item => item.keyword === "dashboard" && item.isView === true) &&
              <li>
                <Link to="/dashboard">
                  <i className="fe-airplay"></i> <span>Dashboard</span>
                </Link>
              </li>
            }
            {permissions === "All" || permissions.some(item => item.keyword === "Keyword" && item.isView === true) &&
              <li>
                <Link to="/profiles/customer">
                  <i className="fas fa-users"></i> Customers
                  {/* <span className="menu-arrow"></span> */}
                </Link>
              </li>
            }
            {cookies.get("login_type") !== "callSupport" && (
              <>
                {/* {permissions !== "All" && permissions.some(item => item.keyword === "profilesCustomers" && item.isView === false) &&
                  permissions.some(item => item.keyword === "profilesOrganisations" && item.isView === false) &&
                  permissions.some(item => item.keyword === "profilesVolunteers" && item.isView === false) ?
                  <></> :
                  <li>
                    <a className="groupMenu" href="#" onClick={handleClick}>
                      <i className="fas fa-users"></i> Profiles
                      <span className="menu-arrow"></span>
                    </a>
                    <ul id="profilesGrp" className="nav-second-level" aria-expanded="false">
                      {permissions === "All" || permissions.some(item => item.keyword === "profilesCustomers" && item.isView === true) &&
                        <li>
                          <Link to="/profiles/customer">Customers</Link>
                        </li>
                      }
                      {permissions === "All" || permissions.some(item => item.keyword === "profilesOrganisations" && item.isView === true) &&
                        <li>
                          <Link to="/profiles/organisation">Organisations</Link>
                        </li>
                      }
                      {permissions === "All" || permissions.some(item => item.keyword === "profilesVolunteers" && item.isView === true) &&
                        <li>
                          <Link to="/profiles/members">Volunteers</Link>
                        </li>
                      }
                    </ul>
                  </li>
                } */}
                {/* {permissions !== "All" && permissions.some(item => item.keyword === "subscriptionManage" && item.isView === false) &&
                  permissions.some(item => item.keyword === "subscriptionList" && item.isView === false) ?
                  <></> :
                  <li>
                    <a className="groupMenu" href="#" onClick={handleClick}>
                      <i className="fa fa-book fa-fw"></i>Subscription
                      <span className="menu-arrow"></span>
                    </a>
                    <ul id="subscriptionGrp" className="nav-second-level" aria-expanded="false">
                      {permissions === "All" || permissions.some(item => item.keyword === "subscriptionManage" && item.isView === true) &&
                        <li>
                          <Link to="/subscription/manage">Manage</Link>
                        </li>
                      }
                      {permissions === "All" || permissions.some(item => item.keyword === "subscriptionList" && item.isView === true) &&
                        <li>
                          <Link to="/subscription/list">List</Link>
                        </li>
                      }
                    </ul>
                  </li>
                } */}
              </>
            )}
            {permissions !== "All" && permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isView === false) &&
              permissions.some(item => item.keyword === "businessProfilesApprovedList" && item.isView == false) &&
              permissions.some(item => item.keyword === "businessProfilesRejectedList" && item.isView == false) ?
              <></> :
              <li>
                <a className="groupMenu" href="#" onClick={handleClick}>
                  <i className="fas fa-building"></i> Business Profiles
                  <span className="menu-arrow"></span>
                </a>
                <ul id="businessProfilesGrp" className="nav-second-level  mm-collapse" aria-expanded="false">
                  {permissions === "All" || permissions.some(item => item.keyword === "businessProfilesPendingList" && item.isView === true) &&
                    <li>
                      <Link to="/BusinessProfile/pendinglist">
                        <span>Pending list</span>
                      </Link>
                    </li>
                  }
                  {permissions === "All" || permissions.some(item => item.keyword === "businessProfilesApprovedList" && item.isView === true) &&
                    <li>
                      <Link to="/BusinessProfile/approvedlist">
                        <span>Approved list</span>
                      </Link>
                    </li>
                  }
                  {permissions === "All" || permissions.some(item => item.keyword === "businessProfilesRejectedList" && item.isView === true) &&
                    <li>
                      <Link to="/BusinessProfile/rejectedlist">
                        <span>Rejected list</span>
                      </Link>
                    </li>
                  }
                </ul>
              </li>
            }

            {permissions === "All" || permissions.some(item => item.keyword === "Keyword" && item.isView === true) &&
              <li>
                <Link to="/keywords/keywords">
                  <BsFillFileWordFill className="ml-1" />
                  <span className="ml-2">Keywords</span>
                </Link>
              </li>
            }


            {permissions !== "All" && permissions.some(item => item.keyword === "sellProductPendingList" && item.isView === false) &&
              permissions.some(item => item.keyword === "sellProductApprovedList" && item.isView === false) &&
              permissions.some(item => item.keyword === "sellProductRejectedList" && item.isView === false) &&
              permissions.some(item => item.keyword === "sellProductExpiredList" && item.isView === false) &&
              permissions.some(item => item.keyword === "sellProductSoldoutList" && item.isView === false) ?
              <></> :
              <li>
                <a className="groupMenu" href="#" onClick={handleClick}>
                  <i className="fe-list"></i> List Products
                  <span className="menu-arrow"></span>
                </a>
                <ul id="sellProducts" className="nav-second-level" aria-expanded="false">
                  {permissions === "All" || permissions.some(item => item.keyword === "sellProductPendingList" && item.isView === true) &&
                    <li>
                      <Link to="/sellProducts/pendinglist" className="waves-effect">
                        <span className="font-size-16">Pending list</span>
                      </Link>
                    </li>}
                  {permissions === "All" || permissions.some(item => item.keyword === "sellProductApprovedList" && item.isView === true) &&
                    <li>
                      <Link to="/sellProducts/approvedlist" className="waves-effect">
                        <span className="font-size-16">Approved list</span>
                      </Link>
                    </li>
                  }
                  {permissions == "All" || permissions.some(item => item.keyword === "sellProductRejectedList" && item.isView == true) &&
                    <li>
                      <Link to="/sellProducts/rejectedlist" className="waves-effect">
                        <span className="font-size-16">Rejected list</span>
                      </Link>
                    </li>
                  }
                  {permissions === "All" || permissions.some(item => item.keyword === "sellProductExpiredList" && item.isView === true) &&
                    <li>
                      <Link to="/sellProducts/expiredlist" className="waves-effect">
                        <span className="font-size-16">Expired list</span>
                      </Link>
                    </li>
                  }
                  {permissions === "All" || permissions.some(item => item.keyword === "sellProductSoldoutList" && item.isView === true) &&
                    <li>
                      <Link to="/sellProducts/soldlist" className="waves-effect">
                        <span className="font-size-16">Soldout list</span>
                      </Link>
                    </li>
                  }
                </ul>
              </li>
            }
                        {permissions !== "All" && permissions.some(item => item.keyword === "buyProductPendingList" && item.isView === false) &&
              permissions.some(item => item.keyword === "buyProductApprovedList" && item.isView === false) &&
              permissions.some(item => item.keyword === "buyProductRejectedList" && item.isView === false) &&
              permissions.some(item => item.keyword === "buyProductExpiredList" && item.isView === false) &&
              permissions.some(item => item.keyword === "buyProductCompletedList" && item.isView === false) ?
              <></> :
              <li>
                <a className="groupMenu" href="#" onClick={handleClick}>
                  <i className="fe-shopping-cart"></i> Product Enquiry
                  <span className="menu-arrow"></span>
                </a>
                <ul id="buyProducts" className="nav-second-level  mm-collapse">
                  {permissions === "All" || permissions.some(item => item.keyword === "buyProductPendingList" && item.isView === true) &&
                    <li>
                      <Link to="/buyProducts/penlist" className="waves-effect Products">
                        <span className="font-size-16">Pending list</span>
                      </Link>
                    </li>}

                  {permissions === "All" || permissions.some(item => item.keyword === "buyProductApprovedList" && item.isView === true) &&
                    <li>
                      <Link to="/buyProducts/applist" className="waves-effect Products">
                        <span className="font-size-16">Approved list</span>
                      </Link>
                    </li>
                  }

                  {permissions === "All" || permissions.some(item => item.keyword === "buyProductRejectedList" && item.isView == true) &&
                    <li>
                      <Link to="/buyProducts/rejlist" className="waves-effect Products">
                        <span className="font-size-16">Rejected list</span>
                      </Link>
                    </li>
                  }

                  {permissions === "All" || permissions.some(item => item.keyword === "buyProductExpiredList" && item.isView == true) &&
                    <li>
                      <Link to="/buyProducts/explist" className="waves-effect Products">
                        <span className="font-size-16">Expired list</span>
                      </Link>
                    </li>
                  }

                  {permissions === "All" || permissions.some(item => item.keyword === "buyProductCompletedList" && item.isView == true) &&
                    <li>
                      <Link to="/buyProducts/complist" className="waves-effect Products">
                        <span className="font-size-16">Completed list</span>
                      </Link>
                    </li>
                  }
                </ul>
              </li>
            }
            {permissions === "All" || permissions.some(item => item.keyword === "settings" && item.isView === true) &&
              <li>
                <Link to="/settings/faq">
                <i className="fas fa-question-circle"></i>
                  <span className="ml-2">FAQ</span>
                </Link>
              </li>
            }
                {permissions === "All" || permissions.some(item => item.keyword === "settings" && item.isView === true) &&
                  <li>
                    <a className="groupMenu" href="#" onClick={handleClick}>
                      <i className="fe-settings"></i>Profile Settings
                      <span className="menu-arrow"></span>
                    </a>
                    <ul id="settingsGrp" className="nav-second-level" aria-expanded="false">
                      {/* <li>
                        <Link to="/settings/vocher">Voucher</Link>
                      </li> */}
                      {/* <li>
                        <Link to="/settings/faq">FAQ's</Link>
                      </li>
                      <li>
                        <Link to="/settings/language">Language</Link>
                      </li> */}
                      <li>
                        <Link to="/settings/userType">Customer Type</Link>
                      </li>
                      {/* <li>
                        <Link to="/settings/intrestedCrops">Intrested Crops</Link>
                      </li> */}
                      <li>
                        <Link to="/settings/btypes">Business Type</Link>
                      </li>
                    </ul>
                  </li>
                }

            {permissions === "All" || permissions.some(item => item.keyword === "survey" && item.isView === true) &&
              <li>
                <Link to="/survey">
                  <FcSurvey className="ml-1" />
                  <span className="ml-2">Survey</span>
                </Link>
              </li>
            }
            {cookies.get("login_type") !== "callSupport" && (
              <>
                {/* {permissions === "All" || permissions.some(item => item.keyword === "coins" && item.isView === true) &&
                  <li>
                    <Link to="/coins/coins">
                      <FaCoins className="ml-1" />
                      <span className="ml-2">Coins</span>
                    </Link>
                  </li>
                } */}
                {/* {permissions === "All" || permissions.some(item => item.keyword === "orders" && item.isView === true) &&
                  <li>
                    <Link to="/orders">
                      <BsFillCartCheckFill className="ml-1" />
                      <span className="ml-2">Orders</span>
                    </Link>
                  </li>
                } */}
                {/* {permissions === "All" || permissions.some(item => item.keyword === "configurations" && item.isView === true) &&
                  <li>
                    <a className="groupMenu" href="#" onClick={handleClick}>
                      <i className="fas fa-users-cog"></i> Configurations
                      <span className="menu-arrow"></span>
                    </a>
                    <ul id="configGrp" className="nav-second-level" aria-expanded="false">
                      <li>
                        <Link to="/configurations/users">Users</Link>
                      </li>
                      <li>
                        <Link to="/configurations/roles">Roles</Link>
                      </li>
                      <li>
                        <Link to="/configurations/rolepermissions">Permissions</Link>
                      </li>
                    </ul>
                  </li>
                } */}

              </>
            )}
            {/* {cookies.get("login_type") !== "callSupport" &&
              (permissions === "All" || permissions.some(item => item.keyword === "settings" && item.isView === true)) && (
                <li>
                  <Link to="/callSupport">
                    <i className="fa fa-headphones"></i>
                    <span>Call Support</span>
                  </Link>
                </li>
              )} */}
          </ul>
        </div>
        <div className="clearfix"></div>
      </Scrollbars>
    </div>
  );
};

export default Sidebar;
